export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  date: string;
  author: string;
  readCount: number;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '南宫集团2026年度战略发布会在京隆重举行',
    summary: '1月15日，南宫集团在北京国家会议中心隆重召开2026年度战略发布会，正式公布未来五年发展规划与三大核心战略方向，来自政府、行业协会及合作伙伴的500余位嘉宾出席本次活动。',
    content: `<p>2026年1月15日，南宫集团在北京国家会议中心隆重召开年度战略发布会。集团董事长南宫明远先生在致辞中回顾了集团过去一年取得的卓越成绩，并对未来发展进行了全面展望。</p>
    <h2>三大核心战略方向</h2>
    <p>南宫明远董事长在发布会上正式公布了集团未来五年的三大战略方向：</p>
    <p><strong>第一，科技引领战略。</strong>集团将持续加大科技研发投入，计划在未来三年内建立三个国家级重点实验室，聚焦人工智能、大数据和物联网等前沿技术领域，力争在核心技术层面实现突破。</p>
    <p><strong>第二，国际化战略。</strong>集团将进一步拓展海外市场版图，重点布局东南亚、中东和非洲等新兴市场，计划在2028年前将海外业务占比提升至集团总营收的40%以上。</p>
    <p><strong>第三，绿色发展战略。</strong>积极响应国家"双碳"目标，集团将在所有业务板块全面推行绿色低碳运营模式，投资建设清洁能源项目，力争2030年前实现集团碳中和目标。</p>
    <h2>合作伙伴反响热烈</h2>
    <p>发布会现场，来自华为、阿里巴巴、腾讯等知名企业的代表纷纷表示，南宫集团的战略规划令人振奋，期待在更多领域开展深度合作。工信部相关领导也对集团在科技创新方面取得的成绩给予了高度肯定。</p>`,
    category: '集团动态',
    date: '2026-01-20',
    author: '南宫集团品牌部',
    readCount: 12580,
    tags: ['战略发布', '科技创新', '国际化', '绿色发展'],
  },
  {
    id: 'article-2',
    title: '南宫集团APP v3.6版本重磅更新：全新界面与智能功能上线',
    summary: '南宫集团官方APP迎来v3.6重大版本更新，全新设计的用户界面、智能推荐系统、以及多项性能优化，为用户带来前所未有的流畅体验。',
    content: `<p>经过研发团队数月精心打磨，南宫集团官方APP v3.6版本于近日正式上线。本次更新是自APP发布以来最大规模的一次版本迭代，在界面设计、功能体验和性能优化方面均有重大突破。</p>
    <h2>全新视觉设计</h2>
    <p>v3.6版本采用了全新的视觉设计语言，以"简洁、高效、温暖"为设计理念，对整体界面进行了重新构建。新界面更加清爽直观，操作流程更加顺畅，无论是新用户还是老用户都能快速上手。</p>
    <h2>智能推荐引擎</h2>
    <p>本次更新最大的亮点是内置了基于AI的智能推荐引擎。系统能够根据用户的使用习惯和偏好，精准推荐个性化的内容和服务，使每位用户都能获得专属的使用体验。</p>
    <h2>性能全面升级</h2>
    <p>技术团队对底层架构进行了深度优化：</p>
    <ul>
    <li>APP启动速度提升60%</li>
    <li>页面切换流畅度提升45%</li>
    <li>内存占用降低30%</li>
    <li>网络请求效率提升50%</li>
    </ul>
    <p>用户可通过南宫集团官方网站或各大应用商店下载最新版本。</p>`,
    category: '产品动态',
    date: '2026-03-08',
    author: '南宫集团产品团队',
    readCount: 8930,
    tags: ['APP更新', '版本发布', '产品优化', '用户体验'],
  },
  {
    id: 'article-3',
    title: '南宫集团获评"2025年度中国最具影响力企业品牌"',
    summary: '在第十二届中国企业品牌发展论坛上，南宫集团凭借卓越的品牌建设与市场影响力，荣获"2025年度中国最具影响力企业品牌"荣誉称号。',
    content: `<p>2025年12月，第十二届中国企业品牌发展论坛在深圳隆重举办。南宫集团凭借多年来在品牌建设、市场拓展和社会责任方面的卓越表现，从众多参评企业中脱颖而出，荣获"2025年度中国最具影响力企业品牌"这一重量级荣誉。</p>
    <h2>评审标准严苛</h2>
    <p>本届评选由商务部国际贸易经济合作研究院指导，联合多家权威机构共同评审。评审维度涵盖品牌知名度、市场占有率、客户满意度、创新能力、社会责任等五大方面，共计18项细分指标。南宫集团在各项评审中均获得高分评价。</p>
    <h2>品牌建设之路</h2>
    <p>自成立以来，南宫集团始终将品牌建设视为企业发展的核心战略。集团建立了完善的品牌管理体系，从产品品质、客户服务、企业文化到社会责任，全方位塑造品牌形象。此次获奖是对集团长期品牌建设工作的充分肯定。</p>`,
    category: '集团动态',
    date: '2025-12-28',
    author: '南宫集团品牌部',
    readCount: 15620,
    tags: ['企业荣誉', '品牌建设', '行业认可'],
  },
  {
    id: 'article-4',
    title: '南宫集团向甘肃地震灾区捐赠1000万元救灾物资',
    summary: '甘肃省发生地震灾情后，南宫集团第一时间启动应急响应机制，通过南宫慈善基金会向灾区捐赠价值1000万元的救灾物资及资金。',
    content: `<p>天灾无情，人间有爱。甘肃省地震灾情发生后，南宫集团第一时间成立应急工作小组，紧急调配物资，通过南宫慈善基金会向灾区捐赠价值1000万元的救灾物资及专项救助资金。</p>
    <h2>快速响应机制</h2>
    <p>南宫集团建立了完善的灾害应急响应机制，能够在灾害发生后的24小时内完成物资调配和捐赠决策。本次捐赠的物资包括帐篷、棉被、食品、饮用水、医疗用品等灾区急需的救援物资。</p>
    <h2>持续关注灾区重建</h2>
    <p>除紧急救援物资外，南宫集团还将持续关注灾区的后续重建工作，计划在灾区学校重建、基础设施修复等方面提供进一步支持。集团董事长南宫明远表示："作为有社会责任感的企业，南宫集团将尽最大努力帮助灾区人民渡过难关、重建家园。"</p>`,
    category: '社会责任',
    date: '2025-11-15',
    author: '南宫集团公关部',
    readCount: 22340,
    tags: ['社会责任', '抗震救灾', '慈善公益'],
  },
  {
    id: 'article-5',
    title: '南宫集团与华为签署战略合作协议，共建智慧产业生态',
    summary: '南宫集团与华为技术有限公司签署全面战略合作协议，双方将在智慧城市、云计算、AI大模型等领域展开深度合作。',
    content: `<p>近日，南宫集团与华为技术有限公司在深圳华为总部签署全面战略合作协议。南宫集团董事长南宫明远与华为轮值董事长徐直军共同出席签约仪式。</p>
    <h2>合作范围广泛</h2>
    <p>根据协议，双方将在以下领域展开深度合作：</p>
    <p><strong>智慧城市建设：</strong>依托华为的数字底座能力与南宫集团的行业资源，共同打造智慧城市整体解决方案。</p>
    <p><strong>云计算服务：</strong>基于华为云平台，为南宫集团旗下企业提供安全可靠的云计算基础设施服务。</p>
    <p><strong>AI大模型应用：</strong>联合开发面向金融、制造、零售等行业的垂直领域大模型应用。</p>
    <h2>打造行业标杆</h2>
    <p>此次合作将充分发挥双方各自的优势，致力于打造行业数字化转型的标杆案例。预计未来三年内，双方合作项目的总产值将突破100亿元。</p>`,
    category: '集团动态',
    date: '2025-10-22',
    author: '南宫集团战略发展部',
    readCount: 9870,
    tags: ['战略合作', '华为', '智慧城市', '云计算'],
  },
  {
    id: 'article-6',
    title: '南宫集团发布2025年ESG报告：绿色发展与可持续未来',
    summary: '南宫集团正式发布2025年度环境、社会及治理（ESG）报告，全面展示集团在可持续发展方面的实践与成效。',
    content: `<p>南宫集团近日正式发布了2025年度环境、社会及治理（ESG）报告。这是集团连续第五年发布ESG报告，全面展示了集团在环境保护、社会责任和公司治理方面的实践成果。</p>
    <h2>环境绩效亮点</h2>
    <p>2025年，南宫集团在环境保护方面取得了显著成效：碳排放强度较2020年下降32%，可再生能源使用比例提升至45%，水资源循环利用率达到78%。集团旗下的生产基地全部通过了ISO 14001环境管理体系认证。</p>
    <h2>社会责任实践</h2>
    <p>在社会责任方面，集团全年投入公益慈善资金超过5000万元，员工志愿服务总时长突破10万小时。集团还设立了"南宫英才奖学金"，累计资助超过2000名品学兼优的困难学生完成学业。</p>`,
    category: '社会责任',
    date: '2025-09-15',
    author: '南宫集团ESG委员会',
    readCount: 7230,
    tags: ['ESG报告', '可持续发展', '绿色低碳', '社会责任'],
  },
];